import { CandyMachine } from '@metaplex-foundation/mpl-candy-machine';
import { getAccountParsingFunction } from '../../../types/Account.mjs';

const parseCandyMachineAccount = getAccountParsingFunction(CandyMachine);

export { parseCandyMachineAccount };
//# sourceMappingURL=CandyMachineAccount.mjs.map
